import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

export const GroupAliasField = (props: { required?: boolean }) => {
  const { required = false } = props;

  return (
    <Form.Item
      label="Group alias"
      required={required}
      name="group_alias"
      rules={
        required ? [{ required: true, message: 'Group alias is required' }] : []
      }
      tooltip="Facebook private group alias."
    >
      <Input placeholder="Fill group alias" sizeType="m" />
    </Form.Item>
  );
};
